// PDF.js worker configuration for react-doc-viewer
import * as pdfjsLib from "pdfjs-dist";

// Production-ready worker source configuration
const getWorkerSrc = () => {
  // In development, use the public directory file
  if (import.meta.env.DEV) {
    return "/pdf.worker.min.mjs";
  }
  // In production, use CDN for reliability - use version 4.8.69 to match package.json
  return "https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs";
};

const workerSrc = getWorkerSrc();

// Set the worker source
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

// Override the Worker constructor to intercept worker creation (development only)
if (typeof window !== "undefined" && import.meta.env.DEV) {
  const OriginalWorker = window.Worker;

  window.Worker = class extends OriginalWorker {
    constructor(scriptURL: string | URL, options?: WorkerOptions) {
      const urlStr =
        typeof scriptURL === "string" ? scriptURL : scriptURL.toString();
      // If the scriptURL contains .vite or is just the worker filename, ensure it uses the public path
      if (
        urlStr.includes("pdf.worker.min.mjs") &&
        !urlStr.startsWith("/") &&
        !urlStr.startsWith("http")
      ) {
        scriptURL = "/pdf.worker.min.mjs";
        console.log("Intercepted worker creation, redirecting to:", scriptURL);
      } else if (
        urlStr.includes(".vite/deps/pdfjs-dist/build/pdf.worker.min.mjs")
      ) {
        scriptURL = "/pdf.worker.min.mjs";
        console.log("Intercepted Vite worker, redirecting to:", scriptURL);
      }
      super(scriptURL, options);
    }
  };
}

// Set global configuration
if (typeof window !== "undefined") {
  (window as any).pdfjsWorkerSrc = workerSrc;
  (window as any).pdfjsLib = pdfjsLib;
}

// Force override the worker source multiple times to ensure it sticks (development only)
if (import.meta.env.DEV) {
  const forceWorkerSrc = () => {
    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
  };

  // Apply immediately and with delays
  forceWorkerSrc();
  setTimeout(forceWorkerSrc, 100);
  setTimeout(forceWorkerSrc, 500);
  setTimeout(forceWorkerSrc, 1000);
}

// console.log("PDF.js worker configured with src:", workerSrc);
// console.log("PDF.js version:", pdfjsLib.version);
// console.log("Environment:", import.meta.env.MODE);
// console.log("Worker version (should match react-pdf): 4.3.136");
// console.log(
//   "Current GlobalWorkerOptions.workerSrc:",
//   pdfjsLib.GlobalWorkerOptions.workerSrc,
// );

export default pdfjsLib;
